import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import SmoothScroll from '../../plugins/smoothScroll'


const propTypes = {
  document: PropTypes.object,
  linkResolver: PropTypes.func,
  // productArray: PropTypes.array,
  // locale: PropTypes.string
}

class ProductGrid extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      isActive: null
    }
    this.toggleModal = this.toggleModal.bind(this)
  }

  toggleModal(id, event) {
    event.preventDefault()
    let st = null;
    if (id > 0) {
      st = "modal" + String(id);
    }
    this.setState({ isActive: st });
  }

  handleClick(e) {
    e.preventDefault()
    SmoothScroll.scrollTo('compare')
  }

  render() {
    let { 
      document,
      linkResolver,
    } = this.props

    return (
      <section className="section-grid">
        <div className="flexbox">
          {
            document.product_list.map((p, index) => {
              const pData = p.product_link.data
              let productLink = p.product_link ? PrismicReact.Link.url(p.product_link, linkResolver) : '/'

              return (

                p.perfect_strain_block === 'No' ? 

                <div key={index} className="flex-item block block-product">
                  <div className="image" style={{ backgroundImage: `url(${pData.product_banner_image.url})`}}></div>
                  <a href="#" className="open-modal anchor-fill" onClick={this.toggleModal.bind(null, index + 1)}></a>
                  <Link to={productLink} className="open-page anchor-fill"></Link>
                  <div className="content">
                    {PrismicReact.RichText.render(pData.product_title)}
                    <div className="content-hover">
                      <p>{p.hover_content_label}</p>
                      <ul className="flexbox strain-info-list">
                        <li>THC: {pData.strain_thc_levels}</li>
                        <li>CBD: {pData.strain_cbd_levels}</li>
                        <li>{pData.strain_type}</li>
                      </ul>
                      <Link to={productLink} className="button button-medium button-white">{p.product_link_name}</Link>
                    </div>
                  </div>
                  <Modal isOpen={this.state.isActive === "modal" + String(index + 1)} className="product-modal">
                    {PrismicReact.RichText.render(pData.product_title)}
                    <h4>{pData.strain_type}</h4>
                    <ul>
                      <li><span>THC:</span> {pData.strain_thc_levels}</li>
                      <li><span>CBD:</span> {pData.strain_cbd_levels}</li>
                      <li><span>{p.good_for_label}</span> {p.good_for_content}</li>
                      <li><span>{p.aroma_label}</span> {p.aroma_content}</li>
                      <li><span>{p.product_type_label}</span> {p.product_type_content}</li>
                      <Link to={productLink} className="button button-medium">{p.product_link_name}</Link>
                    </ul>
                    <button className="button button-close" onClick={this.toggleModal.bind(null, 0)}></button>
                  </Modal>
                </div>

                :

                <div key={index} className="flex-item block block-perfect">
                  <div className="content">
                    {PrismicReact.RichText.render(p.perfect_strain_title)}
                    <div className="content-bottom">
                      {PrismicReact.RichText.render(p.perfect_strain_subtitle)}
                      <a href="#compare" className="button-circle" onClick={this.handleClick}></a>
                    </div>
                  </div>
                </div>

              )
            })
          }
          
        </div>
      </section>
    )
  }
}

ProductGrid.propTypes = propTypes

export default ProductGrid


// WEBPACK FOOTER //
// ./src/components/OurStrains/GridSection.js